import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
const COLORS = ['#4ecca3', '#f1c40f', '#e74c3c', '#3498db', '#9b59b6', '#ff6b6b', '#48dbfb'];
const PARTICLE_COUNT = 60;
const DURATION = 2500;
export function ConfettiAnimation({ trigger }) {
    const canvasRef = useRef(null);
    const [active, setActive] = useState(false);
    useEffect(() => {
        if (trigger === 0)
            return;
        setActive(true);
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        const particles = [];
        for (let i = 0; i < PARTICLE_COUNT; i++) {
            particles.push({
                x: canvas.width / 2 + (Math.random() - 0.5) * 200,
                y: canvas.height / 3,
                color: COLORS[Math.floor(Math.random() * COLORS.length)],
                size: Math.random() * 8 + 4,
                velocityX: (Math.random() - 0.5) * 12,
                velocityY: Math.random() * -12 - 4,
                rotation: Math.random() * 360,
                rotationSpeed: (Math.random() - 0.5) * 10,
            });
        }
        let animId;
        const startTime = Date.now();
        function animate() {
            const elapsed = Date.now() - startTime;
            if (elapsed > DURATION) {
                setActive(false);
                return;
            }
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const progress = elapsed / DURATION;
            particles.forEach((p) => {
                p.x += p.velocityX;
                p.y += p.velocityY;
                p.velocityY += 0.3; // gravity
                p.rotation += p.rotationSpeed;
                ctx.save();
                ctx.translate(p.x, p.y);
                ctx.rotate((p.rotation * Math.PI) / 180);
                ctx.globalAlpha = 1 - progress;
                ctx.fillStyle = p.color;
                ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
                ctx.restore();
            });
            animId = requestAnimationFrame(animate);
        }
        animate();
        return () => {
            cancelAnimationFrame(animId);
        };
    }, [trigger]);
    if (!active)
        return null;
    return (_jsx("canvas", { ref: canvasRef, style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 9999,
        } }));
}
